import { render, staticRenderFns } from "./PIcon.vue?vue&type=template&id=0d0f6574&scoped=true&"
import script from "./PIcon.vue?vue&type=script&lang=ts&"
export * from "./PIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PIcon.vue?vue&type=style&index=0&id=0d0f6574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0f6574",
  null
  
)

export default component.exports